export const SHOW_BUSINESS_MODAL = 'SHOW_BUSINESS_MODAL'
export const UPDATE_ANSWERS = 'UPDATE_ANSWERS'
export const UPDATE_CONTACTS = 'UPDATE_CONTACTS'
export const UPDATE_REASON = 'UPDATE_REASON'
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'

export const SHOW_TIER_MODAL = 'SHOW_TIER_MODAL'

//Actions for survey
export const UPDATE_SURVEY_ANSWERS = 'UPDATE_SURVEY_ANSWERS'
export const REMOVE_SURVEY_ANSWER = 'REMOVE_SURVEY_ANSWER'
export const SET_SURVEY_RESPONSE = 'SET_SURVEY_RESPONSE'
export const DELETE_SURVEY_ANSWER_T2 = 'DELETE_SURVEY_ANSWER_T2'
export const UPDATE_SURVEY_ANSWER_T2 = 'UPDATE_SURVEY_ANSWER_T2'

//Actions for campaign reducer
export const SET_CAMPAIGN = 'SET_CAMPAIGN'
export const SET_CAMPAIGNS = 'SET_CAMPAIGNS'
export const LOADING = 'LOADING'
export const SET_CAMPAIGNS_ASSIGMENTS = 'SET_CAMPAIGNS_ASSIGMENTS' 

export const SET_TOTAL = 'SET_TOTAL'

export const SET_USER_ROLE = 'SET_USER_ROLE'

//Actions for Generic Survey
export const UPDATE_GEN_ANSWER = 'UPDATE_GEN_ANSWER'
export const UPDATE_GEN_RESPONSE = 'UPDATE_GEN_RESPONSE'

//Actions for filters
export const CRS_TYPE_SELECTION = 'CRS_TYPE_SELECTION'
export const CRS_STATUSES_SELECTION = 'CRS_STATUSES_SELECTION'
export const CRS_SEARCH_TITLE_PAGE = 'CRS_SEARCH_TITLE_PAGE'
export const CRS_UNIT_TYPE = 'CRS_UNIT_TYPE'

//Actions for Subtier Survey
export const SET_ST_SUPPLIER_DATA = 'SET_ST_SUPPLIER_DATA'
export const ADD_ST_SUPPLIER_DATA = 'ADD_ST_SUPPLIER_DATA'
export const DELETE_ST_SUPPLIER_DATA = 'DELETE_ST_SUPPLIER_DATA'
export const EDIT_ST_SUPPLIER_DATA = 'EDIT_ST_SUPPLIER_DATA'
export const ADD_COUNTRIES = "ADD_COUNTRIES"
export const UPDATE_COUNTRIES = 'UPDATE_COUNTRIES'
export const ADD_STATES = 'ADD_STATES'

export const UPDATE_OS_CONTACTS = 'UPDATE_OS_CONTACTS'

export const VALIDATE_FIELDS = 'VALIDATE_FIELDS'

//Actions for surveyPartReducer
export const UPDATE_COUNTRY_LIST = 'UPDATE_COUNTRY_LIST'
export const UPDATE_STATES_LIST = 'UPDATE_STATES_LIST'